import React, { Component } from 'react';

import { postJson } from '../../helpers/RequestsHelper'

class Survey3 extends Component {

    state = {
        notes: "",
        notes2: "",
        id: 3,
        localId: ""
    }

    constructor() {
        super()
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {
        let localId = localStorage.getItem("localId");
        if (!localId) {
            const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
            localId = uint32.toString(16)
            localStorage.setItem("localId", localId);
        }
        this.setState({ localId })
    }

    onSubmit = async (e) => {
        let body = this.state

        const cognitoUser = window.userPool.getCurrentUser()

        if (cognitoUser) {
            //This is done for open surveys
            body.userId = cognitoUser.username
        }

        await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/survey/result", body)

        this.setState({ completed: true })
    }

    onChange = (state) => {
        state.completed = false
        this.setState(state)
    }

    validateEmail(email) {
        if (!email) {
            return true
        }
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render() {
        return (
            <div>
                <h1>Feedback form <i className="far fa-lightbulb" style={{ color: "#d01a62" }}></i></h1>

                <br/>
                Please install Tangra Metaverse on Android <a href="https://play.google.com/store/apps/details?id=com.SimplyFlows.Tangra">https://play.google.com/store/apps/details?id=com.SimplyFlows.Tangra</a>
                
                <br />
                <br />
                <br />
                <div onChange={(e) => this.onChange({ setup: e.target.value })}>
                    How would you rate the setup experience?<br />
                    <input type="radio" name="setup" value="veryeasy" autoComplete="off" /> Very Easy
                    <br />
                    <input type="radio" name="setup" value="easy" autoComplete="off" /> Easy
                    <br />
                    <input type="radio" name="setup" value="not easy" autoComplete="off" /> Not easy
                    <br />
                    <input type="radio" name="setup" value="notworking" autoComplete="off" /> Didn't work for me
                </div>

                <br />
                What can we do better?
                <br />
                <textarea className="form-control w-800" onChange={(e) => this.onChange({ notes: e.target.value })} required={true}></textarea>
                
                <br />
                Please list one thing that will make you come back to the app.
                <br />
                <textarea className="form-control w-800" onChange={(e) => this.onChange({ notes2: e.target.value })} required={true}></textarea>
                <br />

                <div>
                    Email or Mechanical Turk ID
                    <br />
                    <input className="form-control w-600"
                        type="text"
                        name="name"
                        autoComplete="name"
                        id="name"
                        onChange={(e) => this.onChange({ name: e.target.value })} />
                    <br />
                </div>
                <br />
                {this.state.completed
                    ? "The code is TANGRA!"
                    : <button className="submit-btn" onClick={this.onSubmit} disabled={this.state.notes.trim() == "" || this.state.notes2.trim() == ""}>Submit</button>
                }
            </div>
        )
    }
}

export default Survey3;